import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  form: {
    padding: `${theme.spacing(2)} 0`,
  },
  aliasForm: {
    padding: '5px 0px',
  },
  addButton: {
    marginBottom: theme.spacing(2),
  },
  cardGrid: {
    maxWidth: 982,
    margin: '0 auto',
  },
  cardLink: {
    color: 'inherit',
    display: 'block',
    textDecoration: 'none',
  },
  settingsCard: {
    alignItems: 'flex-start',
    borderColor: theme.palette.divider,
    borderRadius: 4,
    display: 'flex',
    gap: theme.spacing(3),
    minHeight: 153,
    padding: theme.spacing(2),
    transition: theme.transitions.create(['border-color', 'box-shadow'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    },
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(2),
      minHeight: 'auto',
      padding: theme.spacing(3),
    },
  },
  settingsCardIcon: {
    alignItems: 'center',
    backgroundColor: 'rgba(211, 20, 54, 0.07)',
    borderRadius: 4,
    color: theme.palette.primary.main,
    display: 'flex',
    flex: '0 0 auto',
    height: 60,
    justifyContent: 'center',
    width: 60,
    '& svg': {
      fontSize: 31,
    },
  },
  settingsCardTitle: {
    fontSize: 22,
    fontWeight: 700,
    lineHeight: 1.25,
    marginBottom: theme.spacing(1.5),
  },
  settingsCardDescription: {
    color: theme.palette.text.secondary,
    fontSize: 16,
    lineHeight: 1.5,
  },

  companyUnitsExceeded: {
    marginBottom: '1em',
  },
  companyUnitFooterContainer: {
    width: '100%',
  },
  companyUnitFooterLabel: {
    paddingLeft: '1em',
    display: 'flex',
    alignItems: 'center',
  },
  companyUnitFooterPagination: {
    position: 'relative',
  },
  topButton: {
    borderRadius: ' 50%',
    position: 'fixed',
    bottom: '10px',
    transform: 'translateX(-44px)',
    justifyContent: 'center',
    alignItems: 'center',
    right: 0,
    display: 'flex',
    //height: '46px',
    opacity: .7,
    width: 50,
    height: 50
  },
}));